import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import storage from '../utils/storage';
import { getBackendUrl } from '../utils/api';

const BACKEND_URL = getBackendUrl();

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const [message, setMessage] = useState('');
  const [credits, setCredits] = useState(0);

  useEffect(() => {
    const checkPayment = async () => {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        setStatus('error');
        setMessage('Λείπει το session ID');
        return;
      }

      try {
        const token = storage.getItem('token');
        const response = await axios.get(
          `${BACKEND_URL}/api/checkout/status/${sessionId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data.payment_status === 'paid') {
          setStatus('success');
          setCredits(response.data.credits_amount || 30);
          setMessage(response.data.message || 'Η πληρωμή ολοκληρώθηκε!');
        } else {
          setStatus('pending');
          setMessage('Η πληρωμή δεν έχει ολοκληρωθεί ακόμα...');
        }
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Σφάλμα ελέγχου πληρωμής');
      }
    };

    checkPayment();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-400 via-blue-500 to-purple-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        {status === 'checking' && (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Έλεγχος πληρωμής...</h2>
            <p className="text-gray-600">Παρακαλώ περιμένετε</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="text-6xl mb-4">✅</div>
            <h2 className="text-3xl font-bold text-green-600 mb-4">Επιτυχία!</h2>
            <p className="text-gray-700 mb-6">{message}</p>
            <div className="bg-green-50 p-4 rounded-lg mb-6">
              <p className="text-2xl font-bold text-green-700">{credits} Credits</p>
              <p className="text-sm text-green-600">προστέθηκαν στο λογαριασμό σας</p>
            </div>
            <button
              onClick={() => navigate('/login')}
              className="w-full bg-gradient-to-r from-green-500 to-blue-500 text-white py-3 rounded-lg font-semibold hover:from-green-600 hover:to-blue-600"
            >
              Συνέχεια στη Σύνδεση
            </button>
          </>
        )}

        {status === 'pending' && (
          <>
            <div className="text-6xl mb-4">⏳</div>
            <h2 className="text-2xl font-bold text-yellow-600 mb-4">Εκκρεμεί...</h2>
            <p className="text-gray-700 mb-6">{message}</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-yellow-500 text-white px-6 py-2 rounded-lg hover:bg-yellow-600"
            >
              Ανανέωση
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-6xl mb-4">❌</div>
            <h2 className="text-2xl font-bold text-red-600 mb-4">Σφάλμα</h2>
            <p className="text-gray-700 mb-6">{message}</p>
            <button
              onClick={() => navigate('/signup')}
              className="bg-red-500 text-white px-6 py-2 rounded-lg hover:bg-red-600"
            >
              Προσπάθεια Ξανά
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;